import { Action } from '@ngrx/store';
import { ProjectCharacter } from './project-character.model';

export const ADD = '[ProjectCharacter] Add';
export const ADD_COMPLETE = '[ProjectCharacter] Add Complete';
export const ADD_FAILED = '[ProjectCharacter] Add Failed';

export const UPDATE = '[ProjectCharacter] Update';
export const UPDATE_COMPLETE = '[ProjectCharacter] Update Complete';
export const UPDATE_FAILED = '[ProjectCharacter] Update Failed';

export const DELETE = '[ProjectCharacter] Delete';
export const DELETE_COMPLETE = '[ProjectCharacter] Delete Complete';
export const DELETE_FAILED = '[ProjectCharacter] Delete Failed';

export class AddAction implements Action {
    readonly type = ADD;

    constructor(public payload: ProjectCharacter) { }
}

export class AddCompleteAction implements Action {
    readonly type = ADD_COMPLETE;

    constructor(public payload: ProjectCharacter) { }
}

export class AddFailedAction implements Action {
    readonly type = ADD_FAILED;

    constructor(public payload: any) { }
}

export class UpdateAction implements Action {
    readonly type = UPDATE;

    constructor(public payload: ProjectCharacter) { }
}

export class UpdateCompleteAction implements Action {
    readonly type = UPDATE_COMPLETE;

    constructor(public payload: ProjectCharacter) { }
}

export class UpdateFailedAction implements Action {
    readonly type = UPDATE_FAILED;

    constructor(public payload: any) { }
}

export class DeleteAction implements Action {
    readonly type = DELETE;

    constructor(public payload: ProjectCharacter) { }
}

export class DeleteCompleteAction implements Action {
    readonly type = DELETE_COMPLETE;

    constructor(public payload: ProjectCharacter) { }
}

export class DeleteFailedAction implements Action {
    readonly type = DELETE_FAILED;

    constructor(public payload: any) { }
}

export type Actions
    = AddAction
    | AddCompleteAction
    | AddFailedAction
    | UpdateAction
    | UpdateCompleteAction
    | UpdateFailedAction
    | DeleteAction
    | DeleteCompleteAction
    | DeleteFailedAction;
